import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      // Navigation
      nav: {
        home: 'Inicio',
        reserve: 'Reservar',
        login: 'Iniciar Sesión',
        register: 'Registrarse',
        account: 'Mi Cuenta',
        logout: 'Cerrar Sesión',
        worker: 'Panel Trabajador',
        admin: 'Admin'
      },
      // Hero
      hero: {
        title: 'Parking Premium',
        subtitle: 'Reserva tu plaza de parking por días.',
        cta: 'Reservar Ahora',
        features: {
          secure: 'Seguro 24/7',
          fast: 'Check-in Rápido',
          easy: 'Reserva Fácil'
        }
      },
      // Landing Hero
      landingHero: {
        badge: 'CG Valet Parking · Madrid-Barajas',
        headline1: 'Tú vuelas.',
        headline2: 'Nosotros aparcamos.',
        subheadline1: 'Llega con tu coche a Madrid-Barajas y entrégalo en la',
        subheadline2: 'terminal de tu vuelo',
        subheadline3: 'Lo aparcamos por ti y coordinamos la devolución cuando regreses.',
        benefit1: 'Sin traslados en autobús',
        benefit2: 'Recogida y entrega',
        benefit3: 'Reserva a tu medida',
        cta: 'Reservar mi servicio valet',
        microcopy: 'Elige fechas y terminal · Consulta el importe antes de confirmar',
        priceFrom: 'Desde',
        pricePerDay: '/día',
        discoverMore: 'Conoce nuestro servicio'
      },
      // Booking
      booking: {
        title: 'Reserva tu servicio valet',
        step1: 'Fechas',
        step2: 'Vehículo',
        step3: 'Datos',
        step4: 'Pago',
        startDate: 'Fecha de Entrada',
        endDate: 'Fecha de Salida',
        plate: 'Matrícula',
        brand: 'Marca',
        model: 'Modelo',
        color: 'Color',
        name: 'Nombre Completo',
        email: 'Email',
        phone: 'Teléfono',
        notes: 'Notas (opcional)',
        paymentMethod: 'Método de Pago',
        stripe: 'Pago con Tarjeta',
        cash: 'Pago en Efectivo',
        summary: 'Resumen',
        days: 'días',
        total: 'Total',
        minDays: 'Mínimo 1 día',
        continue: 'Continuar',
        back: 'Atrás',
        confirm: 'Confirmar Reserva',
        pay: 'Pagar con Tarjeta',
        payOnArrival: 'Reservar y Pagar en el Parking'
      },
      // Landing page
      landing: {
        trustBadge: 'Valet con recogida y entrega en Madrid-Barajas',
        headline1: 'Valet Parking',
        headline2: 'en el Aeropuerto',
        subheadline1: 'Conduce hasta la puerta del aeropuerto.',
        subheadline2: 'Nosotros recogemos tu coche',
        subheadline3: 'y te lo devolvemos a tu regreso.',
        benefit1: 'Recogida en terminal',
        benefit2: 'Confirmación inmediata',
        benefit3: 'Parking vigilado 24/7',
        formTitle: 'Calcula tu precio en segundos',
        departureLabel: 'Fecha y hora de SALIDA',
        returnLabel: 'Fecha y hora de REGRESO',
        selectDate: 'Seleccionar fecha',
        priceFrom: 'Desde',
        perDay: '/día',
        bookNow: 'Reservar Ahora',
        freeCancel: 'Cancelación gratuita 24h antes',
        howItWorks: 'Así de fácil funciona',
        step1Title: 'Reserva Online',
        step1Desc: 'Elige fechas, paga y recibe confirmación al instante',
        step2Title: 'Te Recogemos',
        step2Desc: 'Llámanos 30 min antes. Te esperamos en tu terminal',
        step3Title: 'Viaja Tranquilo',
        step3Desc: 'Tu coche en parking vigilado 24/7 con seguro',
        step4Title: 'Te Devolvemos',
        step4Desc: 'A tu regreso, tu coche te espera en la puerta',
        whyChooseUs: '¿Por qué CG Valet?',
        reason1Title: 'Precio Cerrado',
        reason1Desc: 'Sin sorpresas. El precio que ves es el que pagas.',
        reason2Title: 'Seguro Incluido',
        reason2Desc: 'Tu vehículo asegurado durante toda la estancia.',
        reason3Title: 'Sin Esperas',
        reason3Desc: 'Recogida inmediata. Máximo 5 minutos de espera.',
        reason4Title: 'Flexibilidad',
        reason4Desc: 'Cambios de fecha y cancelación gratuita 24h antes.',
        testimonialsTitle: 'Miles de clientes satisfechos',
        ctaTitle: '¿Listo para viajar sin preocupaciones?',
        ctaSubtitle: 'Reserva ahora y olvídate del parking',
        footer: '© 2026 CG Valet Parking. Todos los derechos reservados.'
      },
      // Checkout
      checkout: {
        success: '¡Reserva Confirmada!',
        processing: 'Procesando pago...',
        code: 'Código de Reserva',
        showQR: 'Mostrar QR',
        arrival: 'Llegada',
        departure: 'Salida',
        vehicle: 'Vehículo',
        downloadPass: 'Añadir a Wallet'
      },
      // Worker
      worker: {
        title: 'Panel Trabajador',
        scan: 'Escanear QR',
        arrivals: 'Llegadas Hoy',
        departures: 'Salidas Hoy',
        pending: 'Pendientes',
        completed: 'Finalizados',
        checkin: 'Check-in',
        checkout: 'Check-out',
        complete: 'Completar',
        addNote: 'Añadir Nota',
        assignZone: 'Asignar Zona',
        zones: {
          CUBIERTO: 'Cubierto',
          DESCUBIERTO: 'Descubierto',
          GRANDE: 'Grande',
          VIP: 'VIP'
        },
        scanSuccess: 'Escaneo exitoso',
        scanError: 'Error en escaneo',
        manualInput: 'Entrada Manual',
        enterToken: 'Introducir código QR'
      },
      // Admin
      admin: {
        title: 'Panel Admin',
        reservations: 'Reservas',
        pricing: 'Tarifas',
        blackouts: 'Bloqueos',
        loyalty: 'Fidelización',
        workers: 'Trabajadores',
        reports: 'Reportes',
        export: 'Exportar CSV',
        search: 'Buscar por matrícula, email o código',
        filters: 'Filtros',
        todayArrivals: 'Llegadas Hoy',
        todayDepartures: 'Salidas Hoy',
        pendingIn: 'Pendientes Entrada',
        pendingOut: 'Pendientes Salida'
      },
      // Account
      account: {
        title: 'Mi Cuenta',
        reservations: 'Mis Reservas',
        points: 'Puntos',
        invoices: 'Facturas',
        profile: 'Perfil',
        noReservations: 'No tienes reservas'
      },
      // Common
      common: {
        loading: 'Cargando...',
        error: 'Error',
        success: 'Éxito',
        cancel: 'Cancelar',
        save: 'Guardar',
        delete: 'Eliminar',
        edit: 'Editar',
        view: 'Ver',
        close: 'Cerrar',
        confirm: 'Confirmar',
        yes: 'Sí',
        no: 'No',
        or: 'o'
      },
      // Status
      status: {
        PENDING: 'Pendiente',
        PENDING_PAYMENT: 'Cobro en parking',
        CONFIRMED: 'Confirmada',
        CANCELLED: 'Cancelada',
        COMPLETED: 'Completada',
        NO_SHOW: 'No Presentado',
        PENDING_IN: 'Pendiente Entrada',
        CHECKED_IN: 'Registrado',
        PENDING_OUT: 'Pendiente Salida',
        CHECKED_OUT: 'Entregado',
        PAID: 'PAGADO',
        UNPAID: 'Cobro en parking'
      },
      // Payment Status
      paymentStatus: {
        PAID: 'PAGADO',
        PENDING: 'Cobro en parking',
        PREPAID: 'Pagado por adelantado',
        PAY_AT_PARKING: 'Pago en el parking'
      },
      // Channels
      channels: {
        DIRECT: 'Directo',
        PARKOS: 'Parkos',
        PARKVIA: 'Parkvia', 
        ONEPARK: 'Onepark',
        LOOKING4PARKING: 'Looking4Parking',
        FREE2MOVE: 'Free2Move'
      },
      // Loyalty
      loyalty: {
        title: 'Programa de Fidelidad',
        points: 'Puntos',
        availablePoints: 'Puntos disponibles',
        lifetimePoints: 'Total acumulado',
        tier: 'Nivel',
        referralCode: 'Código de referido',
        copyCode: 'Copiar código',
        applyCode: 'Aplicar código',
        haveCode: '¿Tienes un código de referido?',
        earnPoints: 'Gana puntos por cada euro',
        redeemPoints: 'Canjear puntos',
        minRedemption: 'Mínimo para canjear',
        discount: 'descuento',
        history: 'Historial',
        redeem: 'Canjear',
        overview: 'Resumen',
        howItWorks: '¿Cómo funciona?',
        inviteFriends: 'Invita amigos y gana puntos',
        multiplier: 'Multiplicador',
        progressTo: 'Progreso a'
      },
      // Analytics
      analytics: {
        title: 'Analytics Dashboard',
        totalReservations: 'Total Reservas',
        totalRevenue: 'Ingresos Totales',
        confirmed: 'Confirmadas',
        completed: 'Completadas',
        today: 'Hoy',
        active: 'Activas',
        dailyReservations: 'Reservas e Ingresos Diarios',
        revenueByChannel: 'Ingresos por Canal',
        statusDistribution: 'Estado de Reservas',
        paymentMethods: 'Métodos de Pago',
        reservationsByDay: 'Reservas por Día',
        recentActivity: 'Actividad Reciente',
        period: 'Periodo',
        days: 'días',
        refresh: 'Actualizar'
      },
      // Notifications
      notifications: {
        bookingConfirmed: 'Reserva confirmada',
        bookingModified: 'Reserva modificada',
        bookingCancelled: 'Reserva cancelada',
        reminderTitle: 'Recordatorio',
        callUs: 'Llámanos',
        minutesBefore: 'minutos antes de llegar'
      },
      // Auth
      auth: {
        login: 'Iniciar Sesión',
        register: 'Registrarse',
        email: 'Email',
        password: 'Contraseña',
        confirmPassword: 'Confirmar Contraseña',
        name: 'Nombre',
        phone: 'Teléfono',
        forgotPassword: '¿Olvidaste tu contraseña?',
        noAccount: '¿No tienes cuenta?',
        hasAccount: '¿Ya tienes cuenta?',
        loginError: 'Credenciales inválidas',
        registerError: 'Error al registrar'
      }
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: 'Home',
        reserve: 'Book',
        login: 'Login',
        register: 'Register',
        account: 'My Account',
        logout: 'Logout',
        worker: 'Worker Panel',
        admin: 'Admin'
      },
      // Hero
      hero: {
        title: 'Premium Parking',
        subtitle: 'Book your parking spot by the day.',
        cta: 'Book Now',
        features: {
          secure: '24/7 Secure',
          fast: 'Fast Check-in',
          easy: 'Easy Booking'
        }
      },
      // Landing Hero
      landingHero: {
        badge: 'CG Valet Parking · Madrid-Barajas',
        headline1: 'You fly.',
        headline2: 'We park.',
        subheadline1: 'Drive to Madrid-Barajas and hand over your car at your',
        subheadline2: 'departure terminal',
        subheadline3: 'We park it for you and arrange its return when you land.',
        benefit1: 'No shuttle buses',
        benefit2: 'Pickup and return',
        benefit3: 'Booking that fits your trip',
        cta: 'Book my valet service',
        microcopy: 'Choose dates and terminal · Check the price before confirming',
        priceFrom: 'From',
        pricePerDay: '/day',
        discoverMore: 'Explore our valet service'
      },
      // Booking
      booking: {
        title: 'Book your valet service',
        step1: 'Dates',
        step2: 'Vehicle',
        step3: 'Details',
        step4: 'Payment',
        startDate: 'Entry Date',
        endDate: 'Exit Date',
        plate: 'License Plate',
        brand: 'Brand',
        model: 'Model',
        color: 'Color',
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        notes: 'Notes (optional)',
        paymentMethod: 'Payment Method',
        stripe: 'Pay with Card',
        cash: 'Pay in Cash',
        summary: 'Summary',
        days: 'days',
        total: 'Total',
        minDays: 'Minimum 1 day',
        continue: 'Continue',
        back: 'Back',
        confirm: 'Confirm Booking',
        pay: 'Pay with Card',
        payOnArrival: 'Book & Pay at Parking'
      },
      // Landing page
      landing: {
        trustBadge: '+20,000 customers since 2021',
        headline1: 'Valet Parking',
        headline2: 'at the Airport',
        subheadline1: 'Drive to the airport terminal.',
        subheadline2: 'We pick up your car',
        subheadline3: 'and return it when you\'re back.',
        benefit1: 'Terminal pickup',
        benefit2: 'Instant confirmation',
        benefit3: '24/7 secured parking',
        formTitle: 'Get your price in seconds',
        departureLabel: 'DEPARTURE date & time',
        returnLabel: 'RETURN date & time',
        selectDate: 'Select date',
        priceFrom: 'From',
        perDay: '/day',
        bookNow: 'Book Now',
        freeCancel: 'Free cancellation 24h before',
        howItWorks: 'How it works',
        step1Title: 'Book Online',
        step1Desc: 'Choose dates, pay and get instant confirmation',
        step2Title: 'We Pick Up',
        step2Desc: 'Call us 30 min before. We wait at your terminal',
        step3Title: 'Travel Easy',
        step3Desc: 'Your car in 24/7 secured parking with insurance',
        step4Title: 'We Return',
        step4Desc: 'When you\'re back, your car awaits at the door',
        whyChooseUs: 'Why CG Valet?',
        reason1Title: 'Fixed Price',
        reason1Desc: 'No surprises. The price you see is what you pay.',
        reason2Title: 'Insurance Included',
        reason2Desc: 'Your vehicle insured throughout your stay.',
        reason3Title: 'No Waiting',
        reason3Desc: 'Immediate pickup. Maximum 5 min wait.',
        reason4Title: 'Flexibility',
        reason4Desc: 'Date changes and free cancellation 24h before.',
        testimonialsTitle: 'Thousands of happy customers',
        ctaTitle: 'Ready to travel worry-free?',
        ctaSubtitle: 'Book now and forget about parking',
        footer: '© 2026 CG Valet Parking. All rights reserved.'
      },
      // Checkout
      checkout: {
        success: 'Booking Confirmed!',
        processing: 'Processing payment...',
        code: 'Reservation Code',
        showQR: 'Show QR',
        arrival: 'Arrival',
        departure: 'Departure',
        vehicle: 'Vehicle',
        downloadPass: 'Add to Wallet'
      },
      // Worker
      worker: {
        title: 'Worker Panel',
        scan: 'Scan QR',
        arrivals: 'Today Arrivals',
        departures: 'Today Departures',
        pending: 'Pending',
        completed: 'Completed',
        checkin: 'Check-in',
        checkout: 'Check-out',
        complete: 'Complete',
        addNote: 'Add Note',
        assignZone: 'Assign Zone',
        zones: {
          CUBIERTO: 'Covered',
          DESCUBIERTO: 'Uncovered',
          GRANDE: 'Large',
          VIP: 'VIP'
        },
        scanSuccess: 'Scan successful',
        scanError: 'Scan error',
        manualInput: 'Manual Input',
        enterToken: 'Enter QR code'
      },
      // Admin
      admin: {
        title: 'Admin Panel',
        reservations: 'Reservations',
        pricing: 'Pricing',
        blackouts: 'Blackouts',
        loyalty: 'Loyalty',
        workers: 'Workers',
        reports: 'Reports',
        export: 'Export CSV',
        search: 'Search by plate, email or code',
        filters: 'Filters',
        todayArrivals: 'Today Arrivals',
        todayDepartures: 'Today Departures',
        pendingIn: 'Pending Entry',
        pendingOut: 'Pending Exit'
      },
      // Account
      account: {
        title: 'My Account',
        reservations: 'My Reservations',
        points: 'Points',
        invoices: 'Invoices',
        profile: 'Profile',
        noReservations: 'No reservations yet'
      },
      // Common
      common: {
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        edit: 'Edit',
        view: 'View',
        close: 'Close',
        confirm: 'Confirm',
        yes: 'Yes',
        no: 'No',
        or: 'or'
      },
      // Status
      status: {
        PENDING: 'Pending',
        PENDING_PAYMENT: 'Pay at parking',
        CONFIRMED: 'Confirmed',
        CANCELLED: 'Cancelled',
        COMPLETED: 'Completed',
        NO_SHOW: 'No Show',
        PENDING_IN: 'Pending Entry',
        CHECKED_IN: 'Checked In',
        PENDING_OUT: 'Pending Exit',
        CHECKED_OUT: 'Checked Out',
        PAID: 'PAID',
        UNPAID: 'Pay at parking'
      },
      // Payment Status
      paymentStatus: {
        PAID: 'PAID',
        PENDING: 'Pay at parking',
        PREPAID: 'Prepaid',
        PAY_AT_PARKING: 'Pay at parking'
      },
      // Channels
      channels: {
        DIRECT: 'Direct',
        PARKOS: 'Parkos',
        PARKVIA: 'Parkvia',
        ONEPARK: 'Onepark',
        LOOKING4PARKING: 'Looking4Parking',
        FREE2MOVE: 'Free2Move'
      },
      // Loyalty
      loyalty: {
        title: 'Loyalty Program',
        points: 'Points',
        availablePoints: 'Available points',
        lifetimePoints: 'Lifetime points',
        tier: 'Tier',
        referralCode: 'Referral code',
        copyCode: 'Copy code',
        applyCode: 'Apply code',
        haveCode: 'Have a referral code?',
        earnPoints: 'Earn points per euro',
        redeemPoints: 'Redeem points',
        minRedemption: 'Minimum to redeem',
        discount: 'discount',
        history: 'History',
        redeem: 'Redeem',
        overview: 'Overview',
        howItWorks: 'How it works?',
        inviteFriends: 'Invite friends and earn points',
        multiplier: 'Multiplier',
        progressTo: 'Progress to'
      },
      // Analytics
      analytics: {
        title: 'Analytics Dashboard',
        totalReservations: 'Total Reservations',
        totalRevenue: 'Total Revenue',
        confirmed: 'Confirmed',
        completed: 'Completed',
        today: 'Today',
        active: 'Active',
        dailyReservations: 'Daily Reservations & Revenue',
        revenueByChannel: 'Revenue by Channel',
        statusDistribution: 'Status Distribution',
        paymentMethods: 'Payment Methods',
        reservationsByDay: 'Reservations by Day',
        recentActivity: 'Recent Activity',
        period: 'Period',
        days: 'days',
        refresh: 'Refresh'
      },
      // Notifications
      notifications: {
        bookingConfirmed: 'Booking confirmed',
        bookingModified: 'Booking modified',
        bookingCancelled: 'Booking cancelled',
        reminderTitle: 'Reminder',
        callUs: 'Call us',
        minutesBefore: 'minutes before arrival'
      },
      // Auth
      auth: {
        login: 'Login',
        register: 'Register',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        name: 'Name',
        phone: 'Phone',
        forgotPassword: 'Forgot password?',
        noAccount: "Don't have an account?",
        hasAccount: 'Already have an account?',
        loginError: 'Invalid credentials',
        registerError: 'Registration error'
      }
    }
  },
  fr: {
    translation: {
      // Navigation
      nav: {
        home: 'Accueil',
        reserve: 'Réserver',
        login: 'Connexion',
        register: "S'inscrire",
        account: 'Mon Compte',
        logout: 'Déconnexion',
        worker: 'Panel Employé',
        admin: 'Admin'
      },
      // Hero
      hero: {
        title: 'Parking Premium',
        subtitle: 'Réservez votre place de parking à la journée.',
        cta: 'Réserver Maintenant',
        features: {
          secure: 'Sécurisé 24/7',
          fast: 'Check-in Rapide',
          easy: 'Réservation Facile'
        }
      },
      // Landing Hero
      landingHero: {
        badge: 'CG Valet Parking · Madrid-Barajas',
        headline1: 'Vous prenez votre vol.',
        headline2: 'Nous garons votre voiture.',
        subheadline1: 'Rejoignez Madrid-Barajas et confiez votre voiture à votre',
        subheadline2: 'terminal de départ',
        subheadline3: 'Nous la garons pour vous et organisons sa restitution à votre retour.',
        benefit1: 'Sans navette',
        benefit2: 'Prise en charge et restitution',
        benefit3: 'Une réservation adaptée',
        cta: 'Réserver mon voiturier',
        microcopy: 'Choisissez vos dates et votre terminal · Consultez le prix avant de confirmer',
        priceFrom: 'À partir de',
        pricePerDay: '/jour',
        discoverMore: 'Découvrir notre service'
      },
      // Booking
      booking: {
        title: 'Réservez votre voiturier',
        step1: 'Dates',
        step2: 'Véhicule',
        step3: 'Coordonnées',
        step4: 'Paiement',
        startDate: "Date d'entrée",
        endDate: 'Date de sortie',
        plate: "Plaque d'immatriculation",
        brand: 'Marque',
        model: 'Modèle',
        color: 'Couleur',
        name: 'Nom Complet',
        email: 'Email',
        phone: 'Téléphone',
        notes: 'Notes (optionnel)',
        paymentMethod: 'Mode de Paiement',
        stripe: 'Payer par Carte',
        cash: 'Payer en Espèces',
        summary: 'Résumé',
        days: 'jours',
        total: 'Total',
        minDays: 'Minimum 1 jour',
        continue: 'Continuer',
        back: 'Retour',
        confirm: 'Confirmer la Réservation',
        pay: 'Payer par Carte',
        payOnArrival: 'Réserver et Payer au Parking'
      },
      // Landing page
      landing: {
        trustBadge: '+20 000 clients depuis 2021',
        headline1: 'Voiturier Parking',
        headline2: "à l'Aéroport",
        subheadline1: "Conduisez jusqu'au terminal.",
        subheadline2: 'Nous récupérons votre voiture',
        subheadline3: 'et la rendons à votre retour.',
        benefit1: 'Récupération au terminal',
        benefit2: 'Confirmation instantanée',
        benefit3: 'Parking sécurisé 24/7',
        formTitle: 'Obtenez votre prix en secondes',
        departureLabel: 'Date et heure de DÉPART',
        returnLabel: 'Date et heure de RETOUR',
        selectDate: 'Sélectionner la date',
        priceFrom: 'À partir de',
        perDay: '/jour',
        bookNow: 'Réserver',
        freeCancel: 'Annulation gratuite 24h avant',
        howItWorks: 'Comment ça marche',
        step1Title: 'Réservez en ligne',
        step1Desc: 'Sélectionnez vos dates et recevez une confirmation immédiate',
        step2Title: 'Déposez votre véhicule',
        step2Desc: 'Nous vous attendons à la porte du terminal',
        step3Title: 'Voyagez tranquille',
        step3Desc: 'Votre voiture sécurisée pendant votre absence',
        step4Title: 'Récupération',
        step4Desc: 'Votre véhicule vous attend à la porte'
      },
      // Common
      common: {
        loading: 'Chargement...',
        error: 'Erreur',
        success: 'Succès',
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        edit: 'Modifier',
        close: 'Fermer',
        yes: 'Oui',
        no: 'Non',
        confirm: 'Confirmer',
        search: 'Rechercher'
      },
      // Footer
      footer: {
        copyright: '© 2026 CG Valet Parking. Tous droits réservés.',
        terms: 'Conditions Générales',
        privacy: 'Politique de Confidentialité',
        contact: 'Contact'
      },
      // Success
      success: {
        title: 'Réservation Confirmée!',
        subtitle: 'Votre réservation a été enregistrée avec succès.',
        code: 'Code de réservation',
        details: 'Détails de la réservation',
        entry: 'Entrée',
        exit: 'Sortie',
        vehicle: 'Véhicule',
        total: 'Total',
        pending: 'En attente',
        paid: 'Payé',
        reminder: 'Important: Appelez-nous 30 minutes avant votre arrivée',
        call: 'Appeler maintenant',
        showQR: 'Afficher le QR',
        hideQR: 'Masquer le QR',
        downloadQR: 'Télécharger le QR',
        downloadInvoice: 'Télécharger la Facture PDF',
        myAccount: 'Mon Compte',
        backHome: 'Retour à l\'accueil',
        minutesBefore: 'minutes avant votre arrivée'
      },
      // Auth
      auth: {
        login: 'Connexion',
        register: "S'inscrire",
        email: 'Email',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        name: 'Nom',
        phone: 'Téléphone',
        forgotPassword: 'Mot de passe oublié?',
        noAccount: "Vous n'avez pas de compte?",
        hasAccount: 'Vous avez déjà un compte?',
        loginError: 'Identifiants invalides',
        registerError: "Erreur lors de l'inscription"
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
